import { memo } from 'react';
import { ICardSize, ICategoryListFilters } from '../../types';

interface ICategoryFiltersProps {
  filters: ICategoryListFilters;
  sizes: ICardSize[];
  languages: string[];
  priceSort: string[];
  toggleFilters: (filter: string, value: string) => void;
}

export const CategoryFilters: React.FC<ICategoryFiltersProps> = memo(
  ({ filters, sizes, languages, priceSort, toggleFilters }) => {
    return (
      <div className="category-filters">
        <a href="/" className="clear-filters" style={{ display: 'none' }}>
          Clear Filters
        </a>
        <span>
          <strong className="filter-title">Filters:</strong>
        </span>

        <ul className="filters-list">
          <li>
            <div
              className={
                filters.size.length > 0
                  ? 'custom-dropdown subcategory-dropdown fixed-active'
                  : 'custom-dropdown subcategory-dropdown'
              }
            >
              <a
                href="/"
                onClick={(e) => e.preventDefault()}
                className="custom-dropdown-opener custom-dropdown-opener-changeable active-item"
              >
                {filters.size.length > 0
                  ? sizes.find((x) => x?.size === filters.size[0])?.name || filters.size[0]
                  : 'Size'}
              </a>
              <div className="custom-dropdown-drop subcategory-drop">
                <ul>
                  <li>
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleFilters('size', 'all');
                      }}
                    >
                      All sizes
                    </a>
                  </li>

                  {sizes.map((item, i) => {
                    return (
                      <li key={`${item.size}-${i}`}>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleFilters('size', item.size);
                          }}
                        >
                          {item.size === 'print' ? (
                            <>
                              {item.name}
                              <svg
                                className="svg-drop-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="22"
                                viewBox="0 0 16 22"
                              >
                                <defs>
                                  <style>{`
                                    .cls-1 {
                                      fill: none;
                                      stroke: #191919;
                                    }
                                    `}</style>
                                </defs>
                                <g id="Group_283" transform="translate(-821 -255)">
                                  <g id="Rectangle_123" className="cls-1">
                                    <path d="M0 0H16V22H0z" transform="translate(821 255)" />
                                    <path
                                      fill="none"
                                      d="M0.5 0.5H15.5V21.5H0.5z"
                                      transform="translate(821 255)"
                                    />
                                  </g>
                                  <path
                                    id="Path_109"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5266.392 -591.242)"
                                  />
                                  <path
                                    id="Path_110"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5266.392 -585.121)"
                                  />
                                  <path
                                    id="Path_111"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5266.392 -579)"
                                  />
                                </g>
                              </svg>
                            </>
                          ) : (
                            <>
                              {item.name}
                              <svg
                                className="svg-drop-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                              >
                                <defs>
                                  <style>{`
                                    .cls-1 {
                                      fill: none;
                                      stroke: #191919;
                                    }
                                    `}</style>
                                </defs>
                                <g id="Group_282" transform="translate(-786 -258)">
                                  <g id="Rectangle_122" className="cls-1">
                                    <path d="M0 0H16V16H0z" transform="translate(786 258)" />
                                    <path
                                      fill="none"
                                      d="M0.5 0.5H15.5V15.5H0.5z"
                                      transform="translate(786 258)"
                                    />
                                  </g>
                                  <path
                                    id="Path_112"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5301.392 -588.501)"
                                  />
                                  <path
                                    id="Path_113"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5301.392 -584.621)"
                                  />
                                  <path
                                    id="Path_114"
                                    d="M6090.752 850.621h9.278"
                                    className="cls-1"
                                    transform="translate(-5301.392 -580.741)"
                                  />
                                </g>
                              </svg>
                            </>
                          )}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </li>
          <li>
            <div
              className={
                filters.language.length > 0
                  ? 'custom-dropdown subcategory-dropdown fixed-active'
                  : 'custom-dropdown subcategory-dropdown'
              }
            >
              <a
                href="/"
                onClick={(e) => e.preventDefault()}
                className="custom-dropdown-opener custom-dropdown-opener-changeable active-item"
              >
                {filters.language.length > 0 ? filters.language[0] : 'Language'}
              </a>
              <div className="custom-dropdown-drop subcategory-drop">
                <ul>
                  <li>
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleFilters('language', 'all');
                      }}
                    >
                      All languages
                    </a>
                  </li>
                  {languages.map((item, i) => (
                    <li key={`${item}-${i}`}>
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFilters('language', item);
                        }}
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </li>
          <li>
            <div
              className={
                filters.price.length > 0
                  ? 'custom-dropdown subcategory-dropdown fixed-active'
                  : 'custom-dropdown subcategory-dropdown'
              }
            >
              <a
                href="/"
                onClick={(e) => e.preventDefault()}
                className="custom-dropdown-opener custom-dropdown-opener-changeable active-item"
              >
                {filters.price.length > 0 ? filters.price[0] : 'Price'}
              </a>

              <div
                className="custom-dropdown-drop subcategory-drop"
                style={{ left: 'auto', right: 0 }}
              >
                <ul>
                  <li>
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleFilters('price', 'all');
                      }}
                    >
                      Default
                    </a>
                  </li>

                  {priceSort.map((item, i) => {
                    return (
                      <li key={`${item}-${i}`}>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleFilters('price', item);
                          }}
                        >
                          {item}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
);
